import { render, staticRenderFns } from "./admissionsRep.vue?vue&type=template&id=4f5a3b44&"
import script from "./admissionsRep.vue?vue&type=script&lang=js&"
export * from "./admissionsRep.vue?vue&type=script&lang=js&"
import style0 from "./admissionsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports